<template>

  <!-- 'font-size': '0.8rem', -->
  <div>
    <!-- <el-header > -->

    <!-- </el-header> -->

    <el-main id="themain" v-bind:style="{ height: '70vh', width: fields.length > 30 ? '100vw' : '' }">
      <!-- :table-height="items.length>0?'60vh':'20vh'" -->
      <vuetable ref="vuetable" :css="css.table" :api-mode="false" :fields="fields" :per-page="perPage"
        :data-manager="dataManager" no-data-template pagination-path="pagination" data-path="items"
        :detail-row-component="detailrow" detail-row-class="bg-light" detailRowTransition="g_fadeinout" track-by="_id"
        @vuetable:pagination-data="onPaginationData" @vuetable:cell-dblclicked="celldblclicked"
        @vuetable:cell-clicked="cellclick" @vuetable:cell-rightclicked="cellclick">

        <template slot="tableHeader" slot-scope="props">
          <tableheader :props="props" :sortsetdefault="$store.state.sortset" :matchruledefault="$store.state.matchrule"
            @headersetdone="headersetdone"></tableheader>
          <!-- <VuetableRowHeader></VuetableRowHeader> -->
        </template>


        <div slot="detailrow" slot-scope="props">
          <!-- v-if="props.rowData._id!=currentdetailrowid" -->
          <el-button @click="showdetailrow(props.rowData)" style="font-size: 1rem" type="text">{{
            props.rowData._id === currentdetailrowid ? "&#x274C;" : "More"
          }}</el-button>
          <!-- <p v-else @click="closedetailrow(props.rowData)" type="text">&#x274C;</p> -->
        </div>

        <p slot="sq" slot-scope="props">
          {{ perPage * (currentpage - 1) + props.rowIndex + 1 }}
        </p>

        <cacu slot="cacu" slot-scope="props" :rowData="props.rowData"></cacu>
        <status slot="status" slot-scope="props" :rowData="props.rowData" :rowField="props.rowField"></status>
        <!-- <actionoutin slot="actionin" slot-scope="props" target="qtyincrease" :props="props"></actionoutin>
          <actionoutin slot="actionout" slot-scope="props" target="qtyreduce" :props="props"></actionoutin> -->
        <theform slot="actionin" slot-scope="props" :formname="'actionin'" :props="props" :rowdata="props.rowData">
        </theform>
        <theform slot="actionout" slot-scope="props" :formname="'actionout'" :props="props" :rowdata="props.rowData">
        </theform>
        <theform slot="theform" slot-scope="props" :formname="'theform'" :props="props" :rowdata="props.rowData">
        </theform>
        <theform slot="theform1" slot-scope="props" :formname="'theform1'" :props="props" :rowdata="props.rowData">
        </theform>
        <theform slot="theform2" slot-scope="props" :formname="'theform2'" :props="props" :rowdata="props.rowData">
        </theform>
        <theform slot="theform3" slot-scope="props" :formname="'theform3'" :props="props" :rowdata="props.rowData">
        </theform>
        <inlineform slot="inlineform" slot-scope="props" :props="props" :rowdata="props.rowData"></inlineform>
        <imgdialog slot="img" slot-scope="props" :rowdata="props.rowData"></imgdialog>
        <textfile slot="textfile" slot-scope="props" :rowdata="props.rowData"></textfile>

        <uploadfile slot="uploadfile" slot-scope="props" :rowdata="props.rowData">
        </uploadfile>
        <editfile slot="editfile" slot-scope="props" :rowdata="props.rowData">
        </editfile>

        <!-- 对于limited的dbadmin只能编辑自己名下的条目-->
        <el-button slot="edit" slot-scope="props" type="text" :disabled="
          $store.state.editsid.includes(props.rowData._id) ||
          (!roles.includes('superadmin') &&
            roles.includes('limited') &&
            (!props.rowData.name || props.rowData.name != user))
        " @click="setedit(props.rowData)">&#x270e;</el-button>



        <span slot="printout" slot-scope="props">
          <el-button size="mini" circle icon="el-icon-printer"
            :disabled="$store.state.printsid.includes(props.rowData._id)" @click="setprint(props.rowData)"></el-button>
        </span>

        <el-checkbox slot="tick" slot-scope="props" :value="$store.state.modifysid.includes(props.rowData._id)"
          @change="setmodify(props.rowData)"></el-checkbox>

        <span slot="datatoexcel" slot-scope="props">
          <el-button :disabled="$store.state.printsid.includes(props.rowData._id)"
            @click="datatoexcel(props)">&#946;</el-button>
        </span>
      </vuetable>


    </el-main>
    <el-footer>
      <div style="bottom: 0; padding-top: 0px">
        <!-- <i>{{$refs.pagination?$refs.pagination.lastPage:""}}</i> -->
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"
          :css="css.pagination"></vuetable-pagination>
      </div>
    </el-footer>
  </div>

</template>

<script>
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";


import detailrow from "./detailrow";

import tableheader from "./table_header.vue";
import moment from "moment";
// import jsontoexcel from "js-export-excel";
import uicss from "./vuetablecss.js";
import { fieldsprocess } from "zxg-table-fieldsprocess";
import status from "@/components/utility/commonfields/status";
import cacu from "@/components/utility/commonfields/cacu";
import actionoutin from "@/components/utility/commonfields/actionoutin/index";
//import theform from "@/components/utility/commonfields/theform";
import theform from "@/components/utility/commonfields/form/theform";
// import inlineform from "@/components/utility/commonfields/inlineform";
import inlineform from "@/components/utility/commonfields/form/inlineform";
import imgdialog from "@/components/utility/commonfields/imgdialog";
import textfile from "@/components/utility/commonfields/textfile";
import uploadfile from "@/components/utility/commonfields/file/uploadfile";
import editfile from "@/components/utility/commonfields/file/editfile";




export default {
  components: {
    Vuetable,
    VuetablePaginationInfo,
    VuetablePagination,
    tableheader,
    status,
    cacu,
    actionoutin,
    imgdialog,
    textfile,
    uploadfile,
    editfile,
    VuetableRowHeader,
    theform,
    inlineform,
  },
  data() {

    return {
      popupposition: { x: 0, y: 0, display: "none", type: "", fieldobj: {} },
      currentdetailrowid: "",
      detailrow: detailrow,
      css: uicss,
    };
  },
  computed: {
    roles() {
      return this.$store.state.roles;
    },
    user() {
      return this.$store.state.user;
    },

    items() {
      return this.$store.state.items;
    },
    filter() {
      return this.$store.state.filter;
    },
    searchmodel() {
      return this.$store.state.searchmodel;
    },
    perPage() {
      return this.$store.state.datainformation.perpage;
    },
    currentpage() {
      return this.$store.state.page;
    },
    totalresults() {
      return this.$store.state.datainformation.totalresults;
    },

    // pipe() {
    //   return this.$store.getters.fieldtype;
    // },
    thecollection() {
      return this.$store.state.collection.value;
    },

    fields() {
      return fieldsprocess(this.$store.state.currentheader, "table",this.$store);
    },
    xfield() {
      return this.$store.state.xfield;
    },
    collections() {
      return this.$store.state.collections;
    },

    chartval() {
      return this.$store.state.chartval;
    }, //监听chart上的点击事件

    yvalues() {
      return this.$store.state.yvalues;
    },
  },

  watch: {
    chartval(newVal, oldVal) {
      this.$set(this.filter, this.xfield, "^" + newVal + "$");
      this.$store.commit("setsearchmodel", "filter");
      this.$store.commit("setpage", 1);
      this.$axios.fetchdata();
    },
    // fields(newVal, oldVal){
    //   console.log("table refresh from fields updated")
    //   this.$refs.vuetable.refresh();
    // },
    items:{
      handler(newVal,oldVal){
      console.log("table refresh from items updated")
      this.$refs.vuetable.refresh();
      },
      deep:true
    }
    // items(newVal, oldVal) {
    //   console.log("table refresh from items updated")
    //   this.$refs.vuetable.refresh();
    // },
  },

  methods: {


    headersetdone(obj) {
  
      this.$store.commit("setmatchrule", obj.matchrule)
      this.$store.commit("setsortset", obj.sortset);
      this.$store.commit("setxfield", obj.currentfield.name); //设置x轴
      this.$store.commit("setpage", 1);
      // console.log(this.$store.state.xfield)
      if (obj.currentfield.type === "daterange") {
        this.$axios.fetchdata("datesort");
      } else {
        this.$axios.fetchdata();
      }
    },

    datatoexcel(props) {
      let template = props.rowField.template
      let data = props.rowData
      let model = props.rowField.model

      if (model === "datastoexcel") {
        this.setprint(data)
        return;
      }
      this.$axios
        .post(url + "datatoexcel", { template: template, data: data }, {
          responseType: "blob"
        })
        .then(res => {
          let src = URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.download = this.thecollection + ".xlsx";
          link.href = src;
          link.click();
        });
    },

    // removepopover(popRef) {
    //   var a = this.$refs[popRef].doClose();
    // },
    printout(item) {
      this.$axios.downloadpdf(item.name, this.thecollection, [item]);
    },

    showdetailrow(data) {
      if (this.currentdetailrowid === data._id) {
        this.$refs.vuetable.hideDetailRow(this.currentdetailrowid);
        this.currentdetailrowid = "";
      } else {
        this.$refs.vuetable.hideDetailRow(this.currentdetailrowid);
        this.currentdetailrowid = data._id;
        this.$refs.vuetable.showDetailRow(data._id); //showDetailRow
      }
    },

    setedit(data) {
      this.$store.commit("setedits", data);
      //this.$router.push('/edit')
      //console.log(data)
    },

    setprint(data) {
      this.$message("已添加到打印页面，请到打印页面打印");
      this.$store.commit("setprint", data);
    },

    setmodify(data) {
      this.$message("已选择");
      this.$store.commit("setmodify", data);
    },


    notshow(x) {
      x.visible = false;
    },

    cellclick(obj) {
      // console.log(obj.event)
      if (obj.event.type === "contextmenu") {//|| obj.event.type === "click"
        obj.event.preventDefault();
      }


      let targettxt = window.getSelection().toString();
      let ifselect = targettxt.length > 0
      if (ifselect) { this.$store.commit("settargettxt", targettxt) }


      let popupposition = {
        "fieldobj": obj.field,
        "type": obj.event.type,
        "target": obj.field.name,
        "data": obj.data,
        "value": obj.data[obj.field.name],
        "x": obj.event.clientX + 20,
        "y": obj.event.clientY + 20,
        "selection": ifselect,
        "display": "block"
      }

      for (let k in popupposition) {
        this.$set(this.popupposition, k, popupposition[k]);
      }


      this.$emit("cellclicked", this.popupposition)

    },

    celldblclicked(obj) {
      //判断是否为可搜索
      if (obj.field.filterable === "no") {
        return false;
      }
      //console.log(obj)
      let name = obj.field.name;
      let type = obj.field.type;
      let value = obj.data[name];

      this.$store.commit("setxfield", obj.field.name);

      let thefilter = {};
      if (type == "daterange") {
        //如果数据类型为daterange，将数据设置成相应格式
        let x = [];
        x[0] = moment(value).format("YYYY-MM-DD"); //.toDate();
        x[1] = moment(value).add(1, "day").format("YYYY-MM-DD");

        thefilter[name] = x;
      } else if (type == "numberrange") {
        thefilter[name] = value + " " + (value + 1);
      } else {
        //严格搜索
        thefilter[name] = "^" + value + "$";
      }

      this.$store.commit("setsearchmodel", "filter");
      this.$store.commit("setfilter", thefilter);
      this.$store.commit("setpage", 1);
      this.$axios.fetchdata();
    },

    onPaginationData(paginationData) {
      //console.log(paginationData)
      //this.currentpage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      if (page === "next") {
        page = this.currentpage + 1;
      }
      if (page === "prev") {
        page = this.currentpage - 1;
      }
      this.$refs.vuetable.changePage(page);
      this.$store.commit("setpage", page);

      this.$axios.fetchdata();
    },

    dataManager(sortOrder, pagination) {
      //if (this.items.length < 1) return;

      // let local = this.items;

      pagination = this.$refs.vuetable.makePagination(
        //local.length,
        this.totalresults<10000?this.totalresults:10000,
        this.perPage,
        this.currentpage
      );
      //console.log('pagination:', pagination)
      // let from = pagination.from - 1;
      // let to = from + this.perPage;
      // var aa = local.slice(from, to);
      return {
        pagination: pagination,
        items: this.items,
      };
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.table td {
  vertical-align: middle;
}

.table-sm td,
.table-sm th {
  padding: .1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/presentation/table/table_view.vue